import {Service} from "@/services/superclasses/service";
import {Topic} from "@/interfaces/topic";

const api = window.contextPath + '/rest/topics';

export class TopicService extends Service {

    public loadChildren = async (args: {
        topicId: number,
        first?: number,
        max?: number
    }): Promise<Topic[]> => {
        return this.data(await this.get<Topic[]>(api + "/" + args.topicId + "/children",
            {
                params: {
                    first: args.first,
                    max: args.max
                }
            }))
    }
}

export const topicService = new TopicService()